const TRANSACTION = 'transaction';
const PROCESSING_DEFINITION = '/processing-definition';
const HEALTH_PLAN_TEMPLATES = '/health-plan-templates';
const HEALTH_PLANS = '/health-plans';
export const RENEWALS_SETUP = '/renewals-setup';
export const EXPRESS_SETUPS = '/express-setups';

export default {
  ACCOUNT_ACTIVITY_TRANSACTIONS_VIEW: '/reconciliation-reports/:id/transactions',
  ACCOUNT_ACTIVITY_TRANSACTIONS: (id: string) => `/reconciliation-reports/${id}/transactions`,
  BROKERS: '/brokers',
  CARD_DETAILS: '/card-details',
  CARD_DETAILS_BY_ID: (employeeId?: string, cardId?: string) =>
    `/employee/${employeeId || ':id'}/card-details/${cardId || ':cardId'}`,

  CARDS: '/cards',
  CHANGE_PASSWORD: '/change-password',
  FORGOT_PASSWORD_LINK_SENT: '/forgot-password-link-sent',
  RESET_PASSWORD: '/reset-password',
  CLAIMS_PROCESSOR: (claimId?: string) => `/claims-process/${claimId || ':id'}`,
  CLAIM_PROCESS: '/claims-process',
  CLAIMS: '/claims',
  MANAGE_CLAIMS_PROCESSORS: '/manage-claims-processors',
  COPAY_ADJUDICATION: '/copay-adjudication',
  CARRIER_CONFIG: '/carrier-config',
  EMPLOYEE_VIEW: (id?: string) => `/employee/${id || ':id'}`,
  EMPLOYEE_EDIT_VIEW: (id?: string) => `/employee/${id || ':id'}/edit`,
  EMPLOYEE: '/employee',
  SPENDS_BY_ID: (employeeId?: string | number, userId?: string | number, yearId?: string) =>
    `/spends/${employeeId || ':employeeId'}/user/${userId || ':userId'}/year/${yearId || ':yearId'}`,
  ID_SCAN: (employeeId?: string) => `/id-scan/${employeeId || ':id'}`,
  EMPLOYEES: '/employees',
  TRANSACTION_DETAILS_POSTING: (employeeId?: string, postingId?: string | number) =>
    `/employee/${employeeId || ':id'}/${TRANSACTION}/${postingId || ':postingId'}/posting/`,
  TRANSACTION_DETAILS_CLAIM: (employeeId?: string, claimId?: string | number) =>
    `/employee/${employeeId || ':id'}/${TRANSACTION}/${claimId || ':claimId'}/claim/`,
  TRANSACTION_ENROLLMENT_DETAILS_POSTING: (
    employeeId?: string,
    enrollmentId?: string,
    postingId?: string | number
  ) =>
    `/employee/${employeeId || ':id'}/enrollment/${enrollmentId || ':enrollmentId'}/${TRANSACTION}/${
      postingId || ':postingId'
    }/posting/`,
  TRANSACTION_ENROLLMENT_DETAILS_CLAIM: (
    employeeId?: string,
    enrollmentId?: string,
    claimId?: string | number
  ) =>
    `/employee/${employeeId || ':id'}/enrollment/${enrollmentId || ':enrollmentId'}/${TRANSACTION}/${
      claimId || ':claimId'
    }/claim/`,
  ENROLLMENT_DETAILS: (employeeId?: string, enrollmentId?: string | number) =>
    `/employee/${employeeId || ':id'}/enrollment/${enrollmentId || ':enrollmentId'}`,
  HEALTH_PLAN_SPENDS_DETAILS: (employeeId?: string, healthPlanId?: string, yearId?: string) =>
    `/employee/${employeeId || ':id'}${HEALTH_PLANS}/${healthPlanId || ':healthPlanId'}/year/${
      yearId || ':yearId'
    }`,
  REIMBURSE_ME: (employeeId?: string) => `/employee/${employeeId || ':id'}/reimburse-me`,
  USE_MY_MONEY: (employeeId?: string) => `/employee/${employeeId || ':id'}/use-my-money`,
  USE_MY_MONEY_READY_TO_SCAN: (employeeId?: string) => `/employee/${employeeId || ':id'}/use-my-money/ready-to-scan`,
  USE_MY_MONEY_SUMMARY: (employeeId?: string) => `/employee/${employeeId || ':id'}/use-my-money/summary`,
  USE_MY_MONEY_SETUP_FIELDS: (employeeId?: string) => `/employee/${employeeId || ':id'}/use-my-money/summary/setup-fields`,
  REIMBURSE_ME_FILE_UPLOAD: (employeeId?: string) =>
    `/employee/${employeeId || ':id'}/reimburse-me/file-upload`,
  REIMBURSE_ME_FILE_SCAN: (employeeId?: string) => `/employee/${employeeId || ':id'}/reimburse-me/file-scan`,
  REIMBURSE_ME_CLAIM_INFO: (employeeId?: string) =>
    `/employee/${employeeId || ':id'}/reimburse-me/claim-info`,
  EMPLOYER_SETUP_TEXT: '/employer-setup-test',
  EMPLOYER_SETUP: '/employer-setup',
  EMPLOYERS_CREATE: '/employers/create',
  EMPLOYERS_EDIT: (id?: string) => `/employers/${id || ':id'}/edit`,
  EMPLOYERS_VIEW: '/employers/:id',
  EXPRESS_SETUPS,
  EXPRESS_SETUP_VIEW: (id?: string) => `${EXPRESS_SETUPS}/${id || ':id'}`,
  EXPRESS_SETUP_WIZARD: `${EXPRESS_SETUPS}/wizard/:id`,
  EXPRESS_SETUP_ACTIVATE: `${EXPRESS_SETUPS}/activate/:id`,
  EXPRESS_SETUP_ACTIVITY_LOGS: `${EXPRESS_SETUPS}/activity-logs/:id`,
  EXPRESS_SETUP_BY_ID: (id?: string) => `${EXPRESS_SETUPS}/${id}`,
  EXPRESS_SETUPS_WIZARD_BY_ID: (id?: string) => `${EXPRESS_SETUPS}/wizard/${id}`,
  EXPRESS_SETUPS_ACTIVATE_BY_ID: (id?: string) => `${EXPRESS_SETUPS}/activate/${id}`,
  EXPRESS_SETUPS_ACTIVITY_LOGS_BY_ID: (id?: string) => `${EXPRESS_SETUPS}/activity-logs/${id}`,
  EXPRESS_SETUPS_CREATE_ORGANIZATION: '/create-organization',
  EMPLOYERS: '/employers',
  ERROR: '/error',
  FILE_MANAGER: '/file-manager',
  FILE_SUMMARY: '/file-summary/:id',
  FILE_DETAILS: '/file-summary',
  HELP: '/help',
  HOME: '/',
  INVOICES: '/invoices',
  LOGIN: '/login',
  CONTACT_LOGIN_HISTORY: '/login-history',
  CONTACT_VERIFICATION: '/contacts/email/verifications',
  PLAN_BY_ID: (id: string) => `/plans/${id}`,
  PLAN_SETUP_BY_ID: (id: string) => `/plans/${id}/setup`,
  PLAN_SETUP: '/plans/:id/setup',
  NEW_PLAN: '/plans/:id',
  PLANS: '/plans',

  TEMPLATE_BY_ID: (id: string) => `/templates/${id}`,
  TEMPLATE_SETUP_BY_ID: (id: string) => `/templates/${id}/setup`,
  TEMPLATE: '/templates/:id',
  TEMPLATE_SETUP: '/templates/:id/setup',
  TEMPLATES: '/plans',
  TEMPLATE_VIEW: '/templates',

  HEALTH_PLANS,
  HEALTH_PLAN_HUB: '/health-plan-hub',
  HEALTH_PLAN_TEMPLATES,

  HEALTH_PLAN_TEMPLATE_BY_ID: (id?: string) => `${HEALTH_PLAN_TEMPLATES}/${id || ':id'}`,
  HEALTH_PLAN_TEMPLATE_SETUP_BY_ID: (id?: string) => `${HEALTH_PLAN_TEMPLATES}/${id || ':id'}/setup`,
  HEALTH_PLAN_BY_ID: (id?: string) => `${HEALTH_PLANS}/${id || ':id'}`,
  HEALTH_PLAN_SETUP_BY_ID: (id?: string) => `${HEALTH_PLANS}/${id || ':id'}/setup`,

  HEALTH_PLAN_TEMPLATE: `${HEALTH_PLAN_TEMPLATES}/:id`,
  HEALTH_PLAN_TEMPLATE_SETUP: `${HEALTH_PLAN_TEMPLATES}/:id/setup`,
  HEALTH_PLAN: `${HEALTH_PLANS}/:id`,
  HEALTH_PLAN_SETUP: `${HEALTH_PLANS}/:id/setup`,

  NOT_FOUND: '/404',
  PARTNERS_CREATE: '/partners/create',
  PARTNERS_EDIT: (id?: string) => `/partners/${id || ':id'}/edit`,
  PARTNERS_VIEW: (id?: string) => `/partners/${id || ':id'}`,
  PARTNERS: '/partners',
  DISTRIBUTORS_CREATE: '/distributors/create',
  DISTRIBUTORS: '/distributors',
  DISTRIBUTORS_EDIT: (id?: string) => `/distributors/${id || ':id'}/edit`,
  DISTRIBUTORS_VIEW: (id?: string) => `/distributors/${id || ':id'}`,
  SUBSIDIARY_CREATE: '/subsidiaries/create',
  SUBSIDIARY_EDIT: (id?: string) => `/subsidiaries/${id || ':id'}/edit`,
  SUBSIDIARY_VIEW: (id?: string) => `/subsidiaries/${id || ':id'}`,
  PROCESSING_DEFINITION: `${PROCESSING_DEFINITION}`,
  PAYOUT_DEFINITION_VIEW_BY_ID: (id?: string) => `${PROCESSING_DEFINITION}/${id || ':id'}`,
  PAYOUT_DEFINITION_EDIT_BY_ID: (id?: string) => `${PROCESSING_DEFINITION}/${id || ':id'}/edit`,
  ENROLLMENT_MATRIX: `${PROCESSING_DEFINITION}/enrollment-matrix`,
  PROCESSING_RULES: `${PROCESSING_DEFINITION}/processing-rules`,
  PAYOUT_DEFINITIONS: `${PROCESSING_DEFINITION}/payout-definitions`,
  SERVICES: `${PROCESSING_DEFINITION}/services`,
  PLANS_VIEW: '/plans/:id',

  RECONCILIATION_REPORT_DETAILS: (id: string) => `/reconciliation-reports/${id}`,
  RECONCILIATION_REPORT_VIEW: '/reconciliation-reports/:id',
  FINOPS: '/finops',
  FINOPS_RECON: '/finops/recon',
  FINOPS_INVOICES: '/finops/invoices',
  FINOPS_CHECKS: '/finops/checks',
  FINOPS_LOCKBOXES: '/finops/lockbox',
  FINOPS_PREFUND_VIEW: (id?: string) => `/finops-invoicing/${id || ':id'}`,
  RECONCILIATION_REPORT: '/reconciliation-reports',
  ROLES_AND_SECURITY: '/roles-and-security',
  RENEWALS: '/renewals',
  RENEWALS_SETUP_BY_PLAN_YEAR_ID: (id?: string) => `${RENEWALS_SETUP}/${id || ':id'}`,
  RENEWALS_SETUP,
  LOCKBOX_DETAILS: (lockboxId?: string) => `/lockbox-details/${lockboxId || ':id'}`,

  NEW_REPORTS: '/reports',
  PAYROLL_CONTRIBUTION_REPORT: '/reports/payroll-contribution',
  CLAIMS_ACTIVITY_REPORT: '/reports/claims-activity',
  REPLENISHMENT_INVOICE_REPORT: '/reports/replenishment-invoice',
  CONTRIBUTION_INVOICE_REPORT: '/reports/contribution-invoice',
  PREFUND_INVOICE_REPORT: '/reports/prefund-invoice',
  PLAN_OMNIBUS_BALANCE_REPORT: '/reports/plan-omnibus-balance',
  SCHEDULED_REPORTS: '/reports/scheduled-reports',
  PARTICIPANT_ACTIVITY_REPORT: '/reports/participant-account-activity',
  EMPLOYEE_DEMOGRAPHIC_REPORT: '/reports/employee-demographic',

  FORFEITURE_REPORT: '/reports/forfeiture',
  HEALTH_PLAN_ENROLLMENTS_REPORT: '/reports/health-plan-enrollments',

  CARD_STATUS_REPORT: '/reports/card-status',

  CIP_STATUS_REPORT: '/reports/cip-status',
  CIP_STATUS_REPORT_BY_EMPLOYER_ID: (id?: string) => `/reports/cip-status/${id || ':employerId'}`,

  UNDELIVERABLE_MAIL_REPORT: '/reports/undeliverable-mail',

  DELINQUENT_CLAIMS_REPORT: '/reports/delinquent-claims',

  ROLE_EDIT: (id?: string) => `/role-edit/${id || ':id'}`,
  ROLE_SETUP: '/role-setup',
  FIELD_LEVEL_ACCESS_SETUP: '/field-level-access-setup',
  FIELD_LEVEL_ACCESS_SETUP_EDIT: (id?: string) => `/field-level-access-setup-edit/${id || ':id'}`,

  SETUP_BROKERS: '/setup-brokers',
  SETUP_DISTRIBUTIONS: '/setup-distributions',
  SETUP_HELTHPLANS: '/setup-healthplans',
  SETUP_SUBGROUPS: '/setup-subgroups',
  SETUP_SUBSIDIARIES: '/setup-subsidiaries',
  SUBGROUPS: '/subgroups',
  SUBSIDIARIES: '/subsidiaries',
  SYSTEM_EDIT: '/system/:id/edit',
  SYSTEM_VIEW: '/system/:id',
  SYSTEM: '/system',
  CONTRIBUTION_ACTIVITIES: (contributionId?: string) =>
    `/contributions/${contributionId || ':contributionId'}`,
  SET_UP_CONTRIBUTION: (isCreatingFromTemplate?: boolean) =>
    `/set-up-contribution/${
      typeof isCreatingFromTemplate === 'boolean' ? isCreatingFromTemplate : ':isCreatingFromTemplate'
    }`,
  CONTRIBUTIONS: '/contributions',
  SCHEDULED_CONTRIBUTION_SUMMARY: '/scheduled-contribution/summary',

  SCHEDULED_CONTRIBUTION_EDIT_SUMMARY: (id?: string) => `/scheduled-contribution/summary/edit/${id || ':id'}`,

  MY_DOCUMENTS_LMN_VIEW_MOBILE: (itemId?: string) => `/my-documents/lmn/${itemId || ':itemId'}/view`,
  MY_DOCUMENTS_LMN_EDIT_MOBILE: (itemId?: string) => `/my-documents/lmn/${itemId || ':itemId'}/edit`,
  BANKING_BALANCE: '/finops/banking-balance',
  BANKING_BALANCE_ORG_DETAILS: (orgId?: string) => `/finops/banking-balance/${orgId || ':orgId'}`,
  UNAPPLIED_FUNDS: '/finops/unapplied-funds',
  UNAPPLIED_FUNDS_ORG_DETAILS: (orgId?: string) => `/finops/unapplied-funds/${orgId || ':orgId'}`,

  ACCOUNT_USAGE_DASHBOARD: (planId?: string, planYear?: string) =>
    `/account-usage/${planId || ':planId'}/${planYear || ':planYear'}/`,
};
